import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../../shared/services/language.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { InfoBarWithStatusService } from 'src/app/modules/shared/services/info-bar-with-status.service';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-add-item-project-dialog',
  templateUrl: './add-item-project-dialog.component.html',
  styleUrls: ['./add-item-project-dialog.component.css']
})
export class AddItemProjectDialogComponent implements OnInit {

  variables: any;
  local_data: any;

  invalidMail: boolean = false;
  invalidInputUser: boolean = false;

  errorMail: string = '';
  errorMessageUser: string = '';
  errorMessages: any;

  originalEmail: string = '';

  usersInProject: any[] = [];
  filteredUsers: any[] = [];
  allUsers: any[] = [];

  formGroup1: any;

  constructor(
    public dialogRef: MatDialogRef<AddItemProjectDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService,
    private infoBar: InfoBarWithStatusService,
    private projectService: ProjectsService
  ) {
    this.local_data = { ...data };

  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.usersInProject = this.local_data.usersInProject;
    this.allUsers = this.local_data.allUsers;
    this.filteredUsers = this.allUsers

    if (this.data?.type === 'edit') {
      this.formGroup1 = this._formBuilder.group({
        userNameCtrl: [this.local_data.element.name, Validators.required],
        userFilterCtrl: [this.local_data.element.name],
        userMailCtrl: [this.local_data.element.email, Validators.required]
      });

      this.originalEmail = this.data.element.email;
    }
    else {
      this.formGroup1 = this._formBuilder.group({
        userNameCtrl: ['', Validators.required],
        userFilterCtrl: [''],
        userMailCtrl: ['', Validators.required]
      });
    }

    this.errorMessages = {
      'Project not found': this.variables.project + this.variables.notFound,
      'Email is already in use': this.variables.mailAlreadyExists,
      'Forbidden to add user': this.variables.forbidenAddUsers,
      'Only current owner can add users': this.variables.onlyCurrentOwnerCanAddUsers,
      'A user with this email already exists in the project': this.variables.mailAlreadyExists,
      'User email does not exist in main user collection': this.variables.mailDoesNotExist,
      "Email is required": this.variables.mailRequired
    };
  }


  filterUsers() {
    if (!this.allUsers) {
      return;
    };

    let search = this.formGroup1.get('userFilterCtrl')?.value?.trim();
    if (!search) {
      this.filteredUsers = (this.allUsers.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredUsers = this.allUsers.filter((user: any) => user.name.toLowerCase().indexOf(search) > -1);
  }

  onChangeUsers(user: any) {
    this.cleanErrors();
    this.formGroup1.get('userMailCtrl').setValue(user.email);

  }

  validateUniqueUserName() {
    const nameToValidate = this.formGroup1.get('userNameCtrl')?.value?.trim();

    return !this.usersInProject.some((item: any) =>
      item.name === nameToValidate &&
      (this.data?.type !== 'edit' || item.email !== this.originalEmail)
    );
  }

  validateUniqueUserMail() {
    const emailToValidate = this.formGroup1.get('userMailCtrl')?.value?.trim();

    return !this.usersInProject.some((item: any) =>
      item.email === emailToValidate &&
      (this.data?.type !== 'edit' || item.email !== this.originalEmail)
    );
  }

  cleanErrors() {
    this.invalidInputUser = false;
    this.invalidMail = false;

    this.errorMessageUser = '';
    this.errorMail = '';
  }


  doAction() {
    const formGroup = this.formGroup1.value;

    let valid = true;
    this.cleanErrors()


    if (!this.validateUniqueUserName()) {
      this.invalidInputUser = true;
      this.errorMessageUser = this.variables.alreadyExists;

      valid = false;
    }

    if (!this.validateUniqueUserMail()) {
      this.invalidMail = true;
      this.errorMail = this.variables.alreadyUsedEmail;
      valid = false;
    }

    if (this.formGroup1.valid) {
      if (this.data?.type === 'edit') {
        this.projectService.editUserInProject(this.local_data.projectId, this.formGroup1.value.userNameCtrl, this.formGroup1.value.userMailCtrl, this.local_data.index).subscribe((data: any) => {
          if (data) {
            if (data.success) {
              this.dialogRef.close({ data: { success: true } });
            }
            else {
              this.dialogRef.close({ data: { success: false, error: data.message } });
            }
          }
        },
          (error: any) => {
            console.error('Error adding user:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);


          }
        )
      }
      else {
        this.projectService.addUserToProject(this.local_data.projectId, this.formGroup1.value.userNameCtrl, this.formGroup1.value.userMailCtrl).subscribe((data: any) => {
          if (data) {
            if (data.success) {
              this.dialogRef.close({ data: { success: true } });
            }
            else {
              this.dialogRef.close({ data: { success: false, error: data.message } });
            }
          }
        },
          (error: any) => {
            console.error('Error adding user:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        )
      }
    }
  }
}

